import { createUseStyles } from 'react-jss'
import { commonStyles } from '../../../../modules/shared/subscription-common.styles'

export const useStyles = createUseStyles(theme => {
  const { container } = commonStyles(theme)

  const verticalLayout = {
    container: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: '24px',
      padding: 24,
      textAlign: 'center'
    },

    content: {
      width: '100%',
      gap: '16px'
    },

    messageGroup: {
      width: '100%',
      gap: '16px'
    },

    copy: {
      fontSize: 16,
      fontWeight: 325
    },

    buttons: {
      width: '100%',
      flexDirection: 'column-reverse'
    },

    button: {
      width: '100%'
    }
  }

  return {
    container: {
      ...container,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      animation: '$animateOpacity 0.5s ease-in',
      padding: [24, 100],
      margin: 0,
      maxWidth: '100%',
      width: '100%',
      background: '#191919'
    },

    wrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.white,
      background: 'black',
      boxShadow: 'inset 0px -4px 7px -7px white',
      animation: '$slideOpen 0.5s ease-out'
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      paddingBottom: 4
    },

    messageGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },

    header: {
      fontFamily: 'GothamRounded',
      fontSize: 24,
      fontWeight: 500
    },

    copy: {
      fontFamily: 'GTWalsheim',
      fontSize: 18,
      fontWeight: 500
    },

    buttons: {
      display: 'flex',
      flexDirection: 'row',
      gap: '16px'
    },

    button: {
      padding: [10, 20],
      whiteSpace: 'nowrap'
    },

    [theme.media.tablet]: verticalLayout,
    [theme.media.mobile]: verticalLayout,
    [theme.media.smallMobile]: verticalLayout,

    '@keyframes slideOpen': {
      from: { height: 0 },
      to: { height: 180 }
    },

    '@keyframes animateOpacity': {
      from: { opacity: 0 },
      to: { opacity: 1 }
    }
  }
})
